<template>
  <v-container
      fluid
      grid-list-sm
  >
    <v-toolbar
        color="white"
    >
      <v-toolbar-title
          class="headline"
      >
        {{ $t('citiesPage.cities') }}
      </v-toolbar-title>
      <v-spacer/>
      <v-btn
          v-show="!tableDataLoading"
          @click="openCityDialog(true, null)"
          class="mr-4"
          color="primary"
          dark
      >
        {{ $t('citiesPage.add_city') }}
      </v-btn>
      <v-btn
          @click="readTableData(api, params)"
          :loading="tableDataLoading"
          :disabled="tableDataLoading"
          color="warning"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
    </v-toolbar>
    <v-spacer/>
    <v-data-table
        :mobile-breakpoint="breakpoint"
        :headers="headersFinal"
        :items="tableData"
        :items-per-page="itemsPerPage"
        :footer-props="{itemsPerPageOptions: [10,20,30,50,-1]}"
        :loading-text="$t('citiesPage.loading_data')"
        :loading="tableDataLoading"
        :key="anIncreasingNumber"
        sort-by="name"
        class="elevation-1"
        :dense="true"
    >
      <template
          v-slot:[`item.is_active`]="{ item }"
      >
        <v-chip
            :class="{'error inactive-row white--text':!item.is_active, 'white black--text':item.is_active}"
            small
        >
          {{ item.is_active ? $t('citiesPage.is_active') : $t('citiesPage.not_active') }}
        </v-chip>
      </template>
      <template
          v-slot:[`item.actions`]="{ item }"
      >
        <v-layout
            align-center
            justify-center
        >
          <v-tooltip
              bottom
          >
            <template
                v-slot:activator="{ on, attrs }"
            >
              <v-btn
                  @click.stop="openCityDialog(true, item)"
                  v-bind="attrs"
                  v-on="on"
                  icon
              >
                <v-icon
                    style="color: #ffa21a"
                >
                  mdi-pencil-outline
                </v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t('citiesPage.edit_city') }}
            </span>
          </v-tooltip>
          <v-tooltip
              bottom
          >
            <template
                v-slot:activator="{ on, attrs }"
            >
              <v-btn
                  @click.stop="onDelete(destroyApi,item)"
                  :loading="deleteLoadingId === item.id"
                  v-bind="attrs"
                  v-on="on"
                  icon
              >
                <v-icon
                    v-if="item.is_active"
                    class="red--text"
                >
                  mdi-trash-can-outline
                </v-icon>
                <v-icon
                    v-else
                >
                  mdi-autorenew
                </v-icon>
              </v-btn>
            </template>
            <span>
              {{ item.is_active ? $t('citiesPage.deactivate_city') : $t('citiesPage.reactivate_city') }}
            </span>
          </v-tooltip>
        </v-layout>
      </template>
      <template
          v-slot:[`body.prepend`]
      >
        <tr
            class="grey lighten-2"
        >
          <th
              v-for="header in headers"
              :key="header.name"
              class="py-1"
          >
            <v-select
                v-if="header.name === 'active'"
                v-model="filters[header.value]"
                @change="search"
                :items="activeObjects"
                item-value="value"
                item-text="text"
                class="justify-center"
                style="padding: 0; margin-bottom: -1em !important; font-size: inherit; text-align: right !important;"
            />
            <v-text-field
                v-else-if="header.name !== 'actions'"
                v-model="filters[header.value]"
                @keyup.enter.native="search"
                :placeholder="header.text"
                class="filter-input"
                hide-details
            />
            <v-layout
                v-else
                class="justify-center"
            >
              <v-btn
                  @click="search"
                  :disabled="tableDataLoading"
                  color="primary"
                  depressed
                  small
              >
                <v-icon>
                  mdi-search-web
                </v-icon>
              </v-btn>
              <v-btn
                  @click="refresh(true)"
                  :disabled="tableDataLoading"
                  class="ml-1"
                  color="red"
                  small
                  depressed
              >
                <v-icon
                    color="white"
                >
                  mdi-close-circle
                </v-icon>
              </v-btn>
            </v-layout>
          </th>
        </tr>
      </template>
      <template
          v-slot:[`no-data`]
      >
        <div
            class="text-xs-center pt-3"
        >
          <v-alert
              color="red"
          >
            <span
                class="flex items-center justify-center"
                style="color: white"
            >
              <span>
                {{ $t('citiesPage.no_data') }}
              </span>
              <v-icon
                  class="white-icon ml-2"
              >
                mdi-alert-circle-outline
              </v-icon>
            </span>
          </v-alert>
        </div>
      </template>
    </v-data-table>
    <city-dialog
        v-if="addItemDialog"
        :add-item-dialog="addItemDialog"
        :dataForDialog="dataForDialog"
        @close="addItemDialog=false"
        @addEmit="addEmit"
        @editEmit="editEmit"
    />
    <v-snackbar
        v-model="snackbar.show"
        :bottom="true"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn
          @click="snackbar.show = false"
          dark
          text
      >
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import {
  addEmit,
  editEmit,
  readTableData,
  refresh,
  search,
  findById,
  showSnackbar,
  onDelete
} from "@/statics/DataTableFunctions";

import CityDialog from "@/components/cities/cityAddAndUpdateDialog/cityAddAndUpdateDialog.vue";

export default {
  name: "CitiesPage",
  components: {'city-dialog': CityDialog},
  data() {
    return {
      destroyApi: 'cities/destroy',
      breakpoint: 320,
      tableData: [],
      api: 'cities/index',
      params: {"show_only_active": false},
      itemsPerPage: 10,
      tableDataLoading: false,
      anIncreasingNumber: 1,
      filters: {is_active: ''},
      headers: [],
      addItemDialog: false,
      dataForDialog: {},
      deleteLoadingId: -1,
      snackbar: {
        color: 'success',
        show: false,
        text: '',
        timeout: 3000,
      },
    };
  },
  methods: {
    editEmit,
    addEmit,
    readTableData,
    search,
    refresh,
    findById,
    onDelete,
    openCityDialog(isVisible, item) {
      this.addItemDialog = isVisible;
      this.dataForDialog = item;
    }
  },
  computed: {
    headersFinal: {
      get() {
        return this.headers;
      },
      set(newValue) {
        this.headers = newValue;
      }
    },
    activeObjects() {
      return [
        {value: "", text: this.$t('citiesPage.all')},
        {value: true, text: this.$t('citiesPage.is_active')},
        {value: false, text: this.$t('citiesPage.not_active')}
      ];
    }
  },
  created() {
    this.headersFinal = [
      {
        text: this.$t('citiesPage.name'),
        name: 'name',
        align: 'left',
        sortable: true,
        value: 'name'
      },
      {
        text: this.$t('citiesPage.post_code'),
        name: 'post_code',
        align: 'left',
        sortable: true,
        value: 'post_code'
      },
      {
        text: this.$t('citiesPage.country'),
        name: 'country',
        align: 'left',
        sortable: true,
        value: 'country.name'
      },
      {
        text: this.$t('citiesPage.active'),
        name: 'active',
        align: 'left',
        sortable: true,
        value: 'is_active'
      },
      {text: this.$t('citiesPage.actions'), name: 'actions', align: 'center', sortable: false, value: 'actions'},
    ];
    this.readTableData(this.api, this.params, {});
  }
}
</script>

<style scoped>
.v-toolbar {
  margin-bottom: 15px;
}

.white-icon {
  color: white;
}

.filter-input {
  padding: 12px 0;
  margin-top: -1em !important;
  font-size: inherit;
  text-align: right !important;
}
</style>
